module.exports = __webpack_public_path__ + "img/171.20e2b8a7.jpg";